module.exports = __webpack_public_path__ + "img/content_3.77b8b2a7.png";